<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg6 md6 sm12>
                    <h-currency-input v-model="configuration.Currency" :decimal="0" label="Tỷ giá" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <h-currency-input v-model="configuration.FailedMonth" :decimal="0" label="Số tháng liên tiếp không đạt" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="configuration.MessageTitle" label="Tiêu đề thông báo" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-textarea rows="10" v-model="configuration.Message" label="Nội dung thông báo" class="input-group--focused"></v-textarea>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-textarea rows="10" v-model="configuration.Policy" label="Chính sách" class="input-group--focused"></v-textarea>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="configuration.PriceTable" label="Bảng giá" class="input-group--focused"></v-text-field>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
export default {
    computed: {
        ...mapState({
            loading: state => state.configuration.loading,
            configuration: state => state.configuration.selected
        })
    },
    methods: {
        refreshData() {
            this.$store.dispatch("configuration/getDetail", 1);
        },
        saveData() {
            this.$store.dispatch("configuration/setDetail", {
                data: this.configuration,
                id: this.configuration.ID
            });
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.configuration.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
